import React from 'react';
import { useStoreModal } from './storeModalContext';

const StoreModal: React.FC = () => {
  const { isOpen, close } = useStoreModal();

  React.useEffect(() => {
    if (!isOpen) return;
    const closeBtn = document.getElementById('storeModalClose');
    closeBtn?.focus();
  }, [isOpen]);

  return (
    <div
      className="store-modal-backdrop"
      id="storeModal"
      aria-modal="true"
      role="dialog"
      aria-label="Download Niyyah"
      hidden={!isOpen}
    >
      <button
        type="button"
        aria-label="Close download dialog"
        onClick={close}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          background: 'transparent',
          border: 'none',
          padding: 0,
          cursor: 'default'
        }}
      />
      <div className="store-modal-card" style={{ position: 'relative' }}>
        <button
          className="store-modal-close"
          id="storeModalClose"
          aria-label="Close"
          onClick={close}
          type="button"
        >
          ×
        </button>
        <p className="store-modal-eyebrow">Download Niyyah</p>
        <h2 className="store-modal-title">Which device are you on?</h2>
        <div className="store-modal-btns">
          <a
            href="https://apps.apple.com/gb/app/niyyah-muslimgpt-companion/id6446500974"
            target="_blank"
            rel="noopener noreferrer"
            className="store-btn store-btn-ios"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
            </svg>
            iOS — App Store
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.guider.guidermobile&hl=en_GB"
            target="_blank"
            rel="noopener noreferrer"
            className="store-btn store-btn-android"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 010 2.594zM1.337.924A1.487 1.487 0 001.225 1.492v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195A1.467 1.467 0 002.504.016l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z" />
            </svg>
            Android — Google Play
          </a>
        </div>
      </div>
    </div>
  );
};

export default StoreModal;
